import { Button, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ArrowDownward, ArrowUpward } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { RequestProps } from '../../store/types'
import SortIcon from '@mui/icons-material/Sort'

type SortButtonProps = {
  setRequestProps: React.Dispatch<React.SetStateAction<RequestProps>>
}

const SortButton = ({ setRequestProps }: SortButtonProps) => {
  const { t } = useTranslation()

  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  const states = ['asc', 'desc', 'none']
  const [sortOrder, setSortOrder] = useState<string>('none')

  const toggleButton = () => {
    setSortOrder(prev => states[(states.indexOf(prev) + 1) % states.length])
  }

  useEffect(() => {
    let order = sortOrder === 'asc' ? 1 : 0

    setRequestProps(prev => {
      let newProps: RequestProps = { page: prev.page, size: prev.size }
      let keys = Object.keys(prev)

      for (let key of keys) {
        if (key !== 'sortOrder') {
          newProps = { ...newProps, [key]: prev[key as keyof RequestProps] }
        }
      }

      if (sortOrder !== 'none') return { ...newProps, sortOrder: order }

      return newProps
    })
  }, [setRequestProps, sortOrder])

  return (
    <Button
      onClick={toggleButton}
      variant="text"
      color="secondary"
      aria-label={t(`components.button.sort.${sortOrder}`)}
      sx={{
        width: 'content',
        '&.MuiButtonBase-root': {
          color: 'text.mediumEmphasis',
          '&:hover': {
            color: 'text.highEmphasis',
          },
        },
      }}
    >
      {sortOrder === 'asc' && <ArrowUpward />}
      {sortOrder === 'desc' && <ArrowDownward />}
      {isSmallScreen ? (
        sortOrder === 'none' && <SortIcon />
      ) : (
        <Typography sx={{ px: 1 }}>{t(`components.button.sort.${sortOrder}`)}</Typography>
      )}
    </Button>
  )
}

export default SortButton
